import { restClient } from '@/Core'

import { adminPath } from './diskAdminApi'

/**
 * Попросити власника активного «Мого диска» звільнити місце:
 * `POST /services/disk/admin/storages/{uuid}/cleanup-request` з необов'язковим
 * `message` — сповіщення власнику й запис у журналі адміністратора.
 */
export const RequestDiskCleanupTask = async (uuid: string, message: string): Promise<void> => {
    const text = message.trim()

    await restClient.post(adminPath('storages', uuid, 'cleanup-request'), { json: text !== '' ? { message: text } : {} })
}
